export const TABLE_UPDATE = "ORDER_V2_LOCATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "ORDER_V2_LOCATIONS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "ORDER_V2_LOCATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "ORDER_V2_LOCATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "ORDER_V2_LOCATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "ORDER_V2_LOCATIONS/FETCH_FAILED",
    FETCH_REQUEST: "ORDER_V2_LOCATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "ORDER_V2_LOCATIONS/GET_FAILED",
    GET_REQUEST: "ORDER_V2_LOCATIONS/GET_REQUEST",
    GET_SUCCESS: "ORDER_V2_LOCATIONS/GET_SUCCESS",

    PATCH_FAILED: "ORDER_V2_LOCATIONS/PATCH_FAILED",
    PATCH_REQUEST: "ORDER_V2_LOCATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "ORDER_V2_LOCATIONS/PATCH_SUCCESS",

    STORE_FAILED: "ORDER_V2_LOCATIONS/STORE_FAILED",
    STORE_REQUEST: "ORDER_V2_LOCATIONS/STORE_REQUEST",
    STORE_SUCCESS: "ORDER_V2_LOCATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "ORDER_V2_LOCATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "ORDER_V2_LOCATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "ORDER_V2_LOCATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
